module.exports = "<div ng-show=\"alert.markdown\">\n    <div class=\"global-alert\">\n        <markdown ng-model=\"alert.markdown\"></markdown>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/globalAlert/template.html
// module id = 167
// module chunks = 0